import React, { Component } from 'react';
import { Query } from 'react-apollo';

import Loading from 'src/Components/Loading';
import ErrorView from 'src/Components/Error';
import { query } from 'src/GraphQL/query/MyDepartments.query';

import MyDepartments from './MyDepartments';

export default class MyDepartmentsGQL extends Component {
  render() {
    return (
      <Query query={query} variables={{ includeRound: true, roundDetails: true }}>
        {({ loading, error, data }) => {
          if (loading)
            return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
          if (error) return <ErrorView />;
          const departments = data.myProfile.myDepartmentIds;
          return <MyDepartments data={departments.map(dept => ({ id: dept }))} {...this.props} />;
        }}
      </Query>
    );
  }
}
